import {
  DialogRoot,
  DialogTrigger,
  DialogContent,
  DialogPositioner,
  DialogCloseTrigger,
  DialogTitle,
  DialogDescription,
  DialogBody,
  DialogFooter,
  VStack,
  Input,
  Button,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { User } from "../types/User"; // Import the User type

interface Props {
  initialData: User | null;
  onSubmit: (formData: User) => void;
  triggerElement?: React.ReactNode;
  open: boolean;
  onOpenChange: (details: { open: boolean }) => void;
}

const UserModal = ({ initialData, onSubmit, triggerElement, open, onOpenChange }: Props) => {
  const [form, setForm] = useState<User>({
    name: "",
    email: "",
    role: "",
  });

  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    } else {
      setForm({ name: "", email: "", role: "" });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSubmit(form);
    if (!initialData) {
      setForm({ name: "", email: "", role: "" });
    }
  };

  return (
    <DialogRoot open={open} onOpenChange={onOpenChange}>
      {triggerElement && <DialogTrigger asChild>{triggerElement}</DialogTrigger>}

      <DialogPositioner>
        <DialogContent>
          <DialogTitle>{initialData ? "Edit User" : "Add User"}</DialogTitle>
          <DialogDescription>
            {initialData
              ? "Update user information."
              : "Fill out the form to add a new user."}
          </DialogDescription>

          <DialogBody>
            <VStack gap="3">
              <Input
                placeholder="Name"
                name="name"
                value={form.name}
                onChange={handleChange}
              />
              <Input
                placeholder="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
              />
              <Input
                placeholder="Role"
                name="role"
                value={form.role}
                onChange={handleChange}
              />
            </VStack>
          </DialogBody>

          <DialogFooter gap="2">
            <DialogCloseTrigger asChild>
              <Button variant="outline">Cancel</Button>
            </DialogCloseTrigger>
            <Button colorScheme="blue" onClick={handleSubmit}>
              {initialData ? "Update" : "Create"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogPositioner>
    </DialogRoot>
  );
};

export default UserModal;